"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _usePagination = _interopRequireWildcard(require("../use-pagination"));

var _paginationItem = _interopRequireDefault(require("./pagination-item"));

var _paginationEllipsis = _interopRequireDefault(require("./pagination-ellipsis"));

var _paginationIcon = _interopRequireDefault(require("./pagination-icon"));

var _paginationHighlight = _interopRequireDefault(require("./pagination-highlight"));

var _pagination = require("./pagination.styles");

var _assertion = require("../utils/assertion");

var _clsx = _interopRequireDefault(require("../utils/clsx"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const defaultProps = {
  shadow: false,
  controls: true,
  bordered: false,
  initialPage: 1,
  siblings: 1,
  boundaries: 1,
  dotsJump: 5,
  total: 1,
  loop: false,
  animated: true,
  onlyDots: false,
  noMargin: false,
  rounded: false
};
const preClass = 'nextui-pagination';

const Pagination = ({
  page,
  initialPage,
  onlyDots,
  total,
  loop,
  siblings,
  boundaries,
  shadow,
  animated,
  bordered,
  dotsJump,
  controls,
  noMargin,
  onChange,
  rounded,
  ...props
}) => {
  const {
    range,
    active,
    setPage,
    previous,
    next,
    first,
    last
  } = (0, _usePagination.default)({
    page,
    initialPage,
    siblings: onlyDots ? 10 : siblings,
    boundaries: onlyDots ? 10 : boundaries,
    total,
    onChange
  });
  const renderItem = (0, _react.useCallback)((value, index) => {
    if (value === _usePagination.DOTS) {
      const isBefore = index < range.indexOf(active);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_paginationEllipsis.default, {
        value: value,
        bordered: bordered,
        animated: animated,
        isBefore: isBefore,
        onlyDots: onlyDots,
        onClick: () => isBefore ? setPage(active - dotsJump >= 1 ? active - dotsJump : 1) : setPage(active + dotsJump <= total ? active + dotsJump : total)
      }, `${preClass}-item-${value}-${index}`);
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_paginationItem.default, {
      value: value,
      animated: animated,
      bordered: bordered,
      active: value === active,
      onClick: () => setPage(value),
      onlyDots: onlyDots,
      children: value
    }, `${preClass}-item-${value}-${index}`);
  }, [total, onlyDots, active, bordered, animated]);

  const handleNext = () => {
    if (loop && active === total) {
      return first();
    }

    return next();
  };

  const handlePrevious = () => {
    if (loop && active === 1) {
      return last();
    }

    return previous();
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_pagination.StyledPagination, {
    noMargin: noMargin,
    bordered: bordered,
    rounded: rounded,
    onlyDots: onlyDots,
    className: (0, _clsx.default)(preClass, {
      [`${preClass}--no-margin`]: noMargin,
      [`${preClass}--bordered`]: bordered,
      [`${preClass}--shadow`]: shadow,
      [`${preClass}--rounded`]: rounded
    }),
    ...props,
    children: [controls && /*#__PURE__*/(0, _jsxRuntime.jsx)(_paginationIcon.default, {
      isPrev: true,
      bordered: bordered,
      animated: animated,
      onlyDots: onlyDots,
      onClick: handlePrevious,
      disabled: !loop && active === 1
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_paginationHighlight.default, {
      noMargin: noMargin,
      animated: animated,
      shadow: shadow,
      rounded: rounded,
      active: controls ? range.indexOf(active) + 1 : range.indexOf(active)
    }), range.map(renderItem), controls && /*#__PURE__*/(0, _jsxRuntime.jsx)(_paginationIcon.default, {
      bordered: bordered,
      animated: animated,
      onlyDots: onlyDots,
      onClick: handleNext,
      disabled: !loop && active === total
    })]
  });
};

Pagination.defaultProps = defaultProps;

if (_assertion.__DEV__) {
  Pagination.displayName = 'NextUI - Pagination';
}

Pagination.toString = () => '.nextui-pagination';

var _default = /*#__PURE__*/_react.default.memo(Pagination);

exports.default = _default;
module.exports = exports.default;